<template>
  <div elevation="0" class="no_select text-card" v-if="icon">
    <div class="d-flex align-center" @click="clickCard" style="cursor: pointer">
      <v-icon class="link-arrow-relative" icon="arrow_downward" />
    </div>
  </div>
  <div elevation="0" class="no_select text-card" v-else-if="text">
    <div class="d-flex card-content">
      <div>
        <div class="d-flex align-center" @click="clickCard" style="cursor: pointer">
          <div class="small-prompt">Learn More</div>
          <v-icon class="link-arrow-relative" icon="arrow_downward" />
        </div>
      </div>
      <v-spacer />
    </div>
  </div>
  <v-card
    elevation="2"
    @click="clickCard"
    class="bubble-container no_select"
    v-else
  >
    <div class="d-flex flex-column card-content">
      <div class="d-flex">
        <div>
          <v-img :src="image" class="bubble-icon" />
        </div>
        <v-spacer />
        <div>
          <div class="md-dark bubble-title">{{ title }}</div>
          <div class="md-light bubble-description">{{ description }}</div>
        </div>
      </div>
      <v-spacer />
      <div class="d-flex align-center">
        <div class="md-light bubble-text">Related Article</div>
        <v-spacer />
        <v-icon class="link-arrow" icon="arrow_downward" />
      </div>
    </div>
  </v-card>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    //look in index.js for the route name
    routeName: String,
    //or just enter a string literal for the whole url (this only works in production)
    routeLink: String,
    description: String,
    imageSource: String,
    title: String,
    text: Boolean,
    icon: Boolean,
  },

  computed: {
    image() {
      if (!this.imageSource) {
        return;
      }

      const fileName = this.imageSource;
      return require(`@/assets/${fileName}`);
    },
  },

  data() {
    return {};
  },
  mounted() {},
  methods: {
    clickCard() {
      if (this.routeName) {
        let routeData = this.$router.resolve({ name: this.routeName });
        window.open(routeData.href, "_blank");
      } else if (this.routeLink) {
        window.open(this.routeLink, "_blank");
      }
    },
  },
};
</script>
<style scope>
.bubble-description {
  display: -webkit-box;
  max-height: 60px;
  margin-top: 0;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 14px;
}

.bubble-title {
  margin-bottom: 8px;
}

.bubble-icon {
  width: 44px;
  height: 44px;
  margin-right: 20px;
  margin-bottom: 16px;
}

.bubble-container {
  padding: 16px 20px 12px;
  border-radius: 3px;
  width: 240px;
  height: 130px;
}

.bubble-text {
  letter-spacing: var(--mdc-typography-caption-letter-spacing, 0.0333333333em);
}

.small-prompt {
  color: var(--tf-fg-4);
  font-size: 15px;
  text-decoration: underline;
  cursor: pointer;
  letter-spacing: var(--mdc-typography-caption-letter-spacing, 0.0333333333em);
  margin-left: 32px;
}

.text-card {
  padding-left: 4px;
}
</style>
